import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'attributeNameTransform' })
export class AttributeNameTransform implements PipeTransform {
  nameTransformed: string;
  transform(name: string) {
    this.nameTransformed = name.replace(/[-_]/g, ' ');
    if (this.nameTransformed.length >= 20)
      this.nameTransformed = this.nameTransformed.substring(0, 20) + '..';

    return this.nameTransformed
      .toLowerCase()
      .split(' ')
      .map(char => char.charAt(0).toUpperCase() + char.substring(1))
      .join(' ');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/attributeNameTransform.pipe.ts